import React, { useEffect, useState } from 'react';
import { useFeathers } from '../../app/util';
import { TaskPage, newDraftAfterError } from '../../components';
import { LinkCandidateProfileEditor } from '../../components/LinkCandidateProfileEditor';
import styled from 'styled-components';
import {
  buildCandidateEdit,
  buildLinkCandidateCompletionData,
} from './link-candidate.util';

const LinkCandidate = () => {
  const feathers = useFeathers();
  const [task, setTask] = useState(null);
  const [candidate, setCandidate] = useState(null);
  const [race, setRace] = useState(null);
  const [taskPageSaving, setTaskPageSaving] = useState(false);
  const [completionData, setCompletionData] = useState(null);
  const [candidateEdit, setCandidateEdit] = useState({});

  const onCheckoutTask = async (task, loadNextTask) => {
    setCandidate(null);
    setCandidateEdit(null);
    setRace(null);
    setTask(task);

    let candidate;
    try {
      candidate = await feathers.getService('candidates').get(task.details.candidate);
    } catch (err) {
      if (err.name === 'NotFound') {
        await feathers.getService('research-tasks').patch(task._id, {
          $cancelTask: true,
        });
        setTask(null);
        loadNextTask();
        return;
      }
      throw err;
    }

    setCandidate(candidate);
    setCandidateEdit(buildCandidateEdit(candidate, task));

    const raceId = candidate.race;
    if (raceId) {
      const race = await feathers.getService('races').get(raceId);
      setRace(race);
    }
  };

  useEffect(() => {
    if (candidate && candidateEdit) {
      setCompletionData(buildLinkCandidateCompletionData(candidateEdit));
    }
  }, [candidate, candidateEdit, task]);

  const onCompleteError = (e) => {
    setCandidateEdit((c) => newDraftAfterError(c, e));
  };

  return (
    <TaskPage
      task={task}
      taskType='link-candidate'
      onCheckoutTask={onCheckoutTask}
      completionData={completionData}
      holdingData={candidateEdit}
      onChangeSaving={(saving) => setTaskPageSaving(saving)}
      onCompleteError={onCompleteError}
      completeButtonLabel='Complete and publish'
      autoSaveHoldingData
    >
      <WrapperInner>
        <LinkCandidateProfileEditor
          value={candidateEdit}
          onChange={setCandidateEdit}
          candidateId={candidate?._id}
          photoOptions={candidate?.photoOptions}
          race={race}
          disabled={taskPageSaving}
          electionKey={candidate?.election?.key || candidate?.election}
          stateName={race?.election?.stateName}
        />
      </WrapperInner>
    </TaskPage>
  );
};

const WrapperInner = styled.div`
  padding: 24px 24px 0 0;
`;

export default LinkCandidate;
